import React, {useCallback, useState} from "react"
import {
    MDBBtn,
    MDBCard,
    MDBCardBody,
    MDBCardTitle,
    MDBCol,
    MDBModal,
    MDBModalBody,
    MDBModalContent,
    MDBModalDialog,
    MDBModalHeader,
    MDBModalTitle,
    MDBRow,
} from "mdbreact"

import {useAppDispatch, useAppSelector} from "../../../store"
import {RootState} from "../../../rootReducer"
import {BookingDetail, getBookingUpdateInfo, showBookingLogModal} from "../../../containers/MotBooking/bookingSlice"
import {getSelectedState, Grid, GridColumn, GridSelectionChangeEvent} from "@progress/kendo-react-grid"
import ReactDiffViewer, {DiffMethod} from "react-diff-viewer-continued"
import {getter} from "@progress/kendo-data-query"
import {SpinnerFragment} from "../../../shared/CommonItems"

const DATA_ITEM_KEY = "id"
const SELECTED_FIELD = "selected"
const idGetter = getter(DATA_ITEM_KEY)
const BookingChangeInfoModal = ({booking}: {booking: BookingDetail}) => {
    const [selectedState, setSelectedState] = React.useState<{
        [id: string]: boolean | number[]
    }>({})

    const dispatch = useAppDispatch()
    const showModal = useAppSelector((state: RootState) => state.containers.motBooking.bookingLogModal)
    const logData = useAppSelector((state: RootState) => state.containers.motBooking.bookingUdateInfo)
    const isDataFetched = useAppSelector((state: RootState) => state.containers.motBooking.dataLogModal)

    const onSelectionChange = useCallback(
        (event: GridSelectionChangeEvent) => {
            const newSelectedState = getSelectedState({
                event,
                selectedState: selectedState,
                dataItemKey: DATA_ITEM_KEY,
            })

            setSelectedState(newSelectedState)
        },
        [logData],
    )

    const data = logData.filter((a: any) => a.id == parseInt(Object.keys(selectedState)[0]))
    const oldValue = data.length > 0 && JSON.parse(data[0].oldValues)
    const Value = oldValue
    const newValue = data.length > 0 && JSON.parse(data[0].newValues)

    return (
        <div>
            <MDBModal
                className="lvl-two-popup"
                staticBackdrop
                animationDirection="right"
                show={showModal}
                tabIndex="-1"
            >
                <MDBModalDialog position="top right modal-xl" side>
                    <MDBModalContent className="full-height ">
                        <MDBModalHeader>
                            <MDBModalTitle> {booking.bookingRef} </MDBModalTitle>
                            <MDBBtn
                                color="none"
                                className="btn-close"
                                onClick={() => {
                                    dispatch(showBookingLogModal(false))
                                    dispatch(getBookingUpdateInfo([]))
                                }}
                            ></MDBBtn>
                        </MDBModalHeader>
                        {isDataFetched && <SpinnerFragment />}
                        <MDBModalBody className="pb-0">
                            <MDBRow>
                                <MDBCol md="4">
                                    <MDBCard className="mb-2 pt-1">
                                        <MDBCardBody className="p-2">
                                            <MDBCardTitle>Audit log</MDBCardTitle>
                                            <Grid
                                                data={logData.map(item => ({
                                                    ...item,
                                                    [SELECTED_FIELD]: selectedState[idGetter(item)],
                                                }))}
                                                onSelectionChange={onSelectionChange}
                                                dataItemKey={DATA_ITEM_KEY}
                                                selectedField={SELECTED_FIELD}
                                                selectable={{
                                                    enabled: true,
                                                    drag: false,
                                                    cell: false,
                                                    mode: "single",
                                                }}
                                                style={{
                                                    height: "calc(100vh - 8.5rem)",
                                                }}
                                            >
                                                <GridColumn title="Name" field="userName"></GridColumn>
                                                <GridColumn title="Updated Date" field="dateTimeStamp"></GridColumn>
                                            </Grid>
                                        </MDBCardBody>
                                    </MDBCard>
                                </MDBCol>

                                {data.length > 0 && data[0].auditType === "Update" ? (
                                    <>
                                        <MDBCol md="8" className="pe-4">
                                            <MDBRow>
                                                <MDBCard
                                                    className="mb-2 pt-1"
                                                    style={{height: "calc(100vh - 5.7rem)", overflowX: "auto"}}
                                                >
                                                    <MDBCardBody className="p-2 pb-0">
                                                        {newValue && (
                                                            <ReactDiffViewer
                                                                hideLineNumbers
                                                                oldValue={JSON.stringify(oldValue, null, 4)}
                                                                newValue={JSON.stringify(newValue, null, 4)}
                                                                splitView={true}
                                                                compareMethod={DiffMethod.WORDS}
                                                                showDiffOnly={false}
                                                                styles={{
                                                                    diffContainer: {
                                                                        minWidth: 'unset'
                                                                    }
                                                                    }}
                                                                leftTitle="
                                                                Old Values"
                                                                rightTitle={`New Values${
                                                                    data.length > 0 &&
                                                                    ` - ${data[0].auditType}d ${data[0].dateTimeStamp}`
                                                                }`}
                                                            />
                                                        )}
                                                    </MDBCardBody>
                                                </MDBCard>
                                            </MDBRow>
                                        </MDBCol>
                                    </>
                                ) : (
                                    <MDBCol md="8" className="pe-4">
                                        <MDBRow>
                                            <MDBCard
                                                className="mb-2 pt-1"
                                                style={{height: "calc(100vh - 5.7rem)", overflowX: "auto"}}
                                            >
                                                <MDBCardBody className="p-2 pb-0">
                                                    {newValue && (
                                                        <ReactDiffViewer
                                                            hideLineNumbers
                                                            newValue={JSON.stringify(newValue, undefined, 4)}
                                                            splitView={false}
                                                             styles={{
                                                            diffContainer: {
                                                                minWidth: 'unset'
                                                            }
                                                            }}
                                                            leftTitle={`New Values${
                                                                data.length > 0 &&
                                                                ` - ${data[0].auditType}d ${data[0].dateTimeStamp}`
                                                            }`}
                                                        />
                                                    )}
                                                </MDBCardBody>
                                            </MDBCard>
                                        </MDBRow>
                                    </MDBCol>
                                )}
                            </MDBRow>
                        </MDBModalBody>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
        </div>
    )
}

export default BookingChangeInfoModal
